"use client";

import { useQueryState } from "nuqs";

import { brandConfig } from "../../model/brandConfig";
import { brandCatigory } from "../../model/brandCategory";

import { updateQueryParam } from "@/shared/lib/helpers";

const ProductBrand = () => {
  const [brand, setBrand] = useQueryState(brandConfig.PARAM_NAME);

  const handleBrand = (brand: string) => {
    updateQueryParam(brand, setBrand);
  };

  return (
    <>
      <label htmlFor="brandSelect" className="sr-only">
        бренди
      </label>
      <select
        id="brandSelect"
        onChange={(e) => handleBrand(e.target.value)}
        className="field"
        value={brand ?? ""}
      >
        <option value="">Усі бренди</option>
        {brandCatigory.map((brand) => (
          <option key={brand.id} value={brand.slug}>
            {brand.name}
          </option>
        ))}
      </select>
    </>
  );
};

export { ProductBrand };
